import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import {
  Bell,
  Check,
  LUCIDE_ICONS,
  LucideAngularModule,
  LucideIconProvider,
  X,
} from 'lucide-angular';
import { Observable } from 'rxjs';
import { Novedad, RolPlataforma } from '../../../core/models/novedades.models';
import { NovedadesService } from '../../../core/services/novedades.service';
import { formatNotificationDate } from '../../../core/utils/date-format.util';

@Component({
  selector: 'app-header-notification-bell',
  imports: [CommonModule, LucideAngularModule],
  providers: [
    {
      provide: LUCIDE_ICONS,
      multi: true,
      useValue: new LucideIconProvider({ Bell, X, Check }),
    },
  ],
  templateUrl: './header-notification-bell.html',
  styleUrl: './header-notification-bell.css',
})
export class HeaderNotificationBell implements OnInit, OnChanges {
  @Input() rol: RolPlataforma = 'postulante';

  modalAbierto = false;
  readonly conteoNoLeidas$: Observable<number>;
  readonly notificaciones$: Observable<Novedad[]>;

  get mostrarCampana(): boolean {
    return this.rol === 'postulante';
  }

  constructor(
    private readonly novedadesService: NovedadesService,
    private readonly router: Router
  ) {
    this.conteoNoLeidas$ = this.novedadesService.conteoNoLeidas$;
    this.notificaciones$ = this.novedadesService.notificaciones$;
  }

  ngOnInit(): void {
    if (this.mostrarCampana) {
      this.novedadesService.getNovedadesPorRol(this.rol).subscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rol'] && this.mostrarCampana) {
      this.novedadesService.getNovedadesPorRol(this.rol).subscribe();
    }
  }

  abrirModal(): void {
    this.modalAbierto = true;
  }

  cerrarModal(): void {
    this.modalAbierto = false;
  }

  irATodas(): void {
    this.cerrarModal();
    this.router.navigate(['/actualizaciones'], {
      queryParams: { role: this.rol },
    });
  }

  abrirDetalle(item: Novedad): void {
    if (!item.leida) {
      this.novedadesService.marcarComoLeida(item.id);
    }
    this.cerrarModal();
    if (item.accionRuta) {
      this.router.navigate([item.accionRuta], {
        queryParams: item.accionQueryParams,
      });
    } else {
      this.router.navigate(['/postulaciones'], {
        queryParams: { role: this.rol },
      });
    }
  }

  formatoFecha(fecha?: string): string {
    return formatNotificationDate(fecha);
  }
}
